import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3 row justify-content-center" }

import Api from "@/services/api";
    import { User } from "@/services/types";
    import { ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus";
    import { onBeforeMount, reactive, ref } from "vue";
    import { useRouter } from "vue-router";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

    const router = useRouter()
    const loading = ref<boolean>(true)
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const user = reactive<User>({
        name: '',
        phone: null,
        password: '',
        role: 'admin'
    })

    const rules = reactive<FormRules<User>>({
        name: [{required: true, message: 'Informe seu nome', min: 2}],
        phone: [{required: true, message: 'Informe seu numero'}],
        password: [{required: false}],
    })

    onBeforeMount(async () => {
        loading.value = true
        const res = await Api.get('auth/user')
        if (res.status != 200) {
            ElMessageBox.alert('Ocorreu um erro ao prourar seu perfil', {
                type: "error"                
            }).then(() => {
                router.push('/login')
            })
        } else {
            const data = res.data.user
            user.name = data.name
            user.phone = data.phone
            user.role = data.role
        }
        loading.value = false
    })

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const data = Object.assign({}, user)
                if (user.password?.length && user.password?.length <= 0 || !user.password) {
                    delete data.password
                }
                const res = await Api.put('auth/user', data)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Dados atualizados com sucesso'})
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        const erros = res.data.errors
                        console.log(formRef.value)
                        formRef.value?.fields.forEach((val) => {
                            console.log(val)
                            Object.keys(erros).forEach(field => {
                                if (val.prop == field) {
                                    val.validateState = "error"
                                    ElMessage({
                                        type: "error",
                                        message: res.data.errors[field][0]
                                    })
                                }
                            })
                        })
                    }
                } else {
                    ElMessage.error({message: "Ocorreu um erro " + res.data.message})
                }
                saving.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "col-12 col-md-8 col-lg-5",
      header: "Meu perfil"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_skeleton, {
          loading: loading.value,
          animated: "",
          rows: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              disabled: saving.value,
              model: user,
              "label-position": "top",
              rules: rules,
              ref_key: "formRef",
              ref: formRef
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "Seu nome",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      modelValue: user.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.name) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Numero de telefone",
                  prop: "phone"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      modelValue: user.phone,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.phone) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Alterar senha",
                  prop: "password"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "password",
                      modelValue: user.password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.password) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  loading: saving.value,
                  onClick: _cache[3] || (_cache[3] = () => submit(formRef.value)),
                  size: "large",
                  plain: "",
                  type: "primary",
                  icon: "Select"
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" Salvar alterações ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }, 8, ["disabled", "model", "rules"])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    })
  ]))
}
}

})